import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/ui/select";
import { useUnitItemContext } from "@/hooks/useUnitItemContext";
import type { UnitPromotion } from "@/types";

interface UnitPromotionsProps {
    promotions: UnitPromotion[];
}

export const UnitPromotions = ({ promotions }: UnitPromotionsProps) => {
    const unitContext = useUnitItemContext();

    const { selectedPromo, setSelectedPromo } = unitContext;

    return promotions.length === 1 ? (
        <span className="unit-item-promotion">{promotions[0].name}</span>
    ) : promotions.length > 1 ? (
        <Select
            value={selectedPromo.toString()}
            onValueChange={(value) =>
                setSelectedPromo((prev) =>
                    prev === Number(value) ? prev : Number(value),
                )
            }
        >
            <SelectTrigger
                className="unit-item-promotions tw:max-w-[280px]"
                title="Unit Promotion"
            >
                <SelectValue placeholder="Select a promotion" />
            </SelectTrigger>
            <SelectContent className="se-vapor se-vapor-promotions tw:z-max">
                {promotions.map((promo) => (
                    <SelectItem
                        key={promo.id.toString()}
                        value={promo.id.toString()}
                    >
                        <span className="tw:font-bold">{promo.name}</span>
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    ) : null;
};
